/* Catálogo completo dos 66 livros da Bíblia em pt-BR.
 *
 * Cada entrada inclui:
 *   - slug:     slug de rota no app (sem acento, usado em /biblia/:slug)
 *   - apiSlug:  slug aceito por https://bible-api.com (translation=almeida)
 *   - name:     nome completo em português
 *   - abbr:     abreviação pastoral comum (ex: "Jo", "1Co")
 *   - testament:"AT" | "NT"
 *   - chapters: número total de capítulos
 *
 * Ordem preservada para exibição canônica.
 */

export const BIBLE_BOOKS = [
  // Antigo Testamento, Pentateuco
  { slug: "genesis", apiSlug: "genesis", name: "Gênesis", abbr: "Gn", testament: "AT", chapters: 50 },
  { slug: "exodo", apiSlug: "exodo", name: "Êxodo", abbr: "Ex", testament: "AT", chapters: 40 },
  { slug: "levitico", apiSlug: "levitico", name: "Levítico", abbr: "Lv", testament: "AT", chapters: 27 },
  { slug: "numeros", apiSlug: "numeros", name: "Números", abbr: "Nm", testament: "AT", chapters: 36 },
  { slug: "deuteronomio", apiSlug: "deuteronomio", name: "Deuteronômio", abbr: "Dt", testament: "AT", chapters: 34 },
  // Históricos
  { slug: "josue", apiSlug: "josue", name: "Josué", abbr: "Js", testament: "AT", chapters: 24 },
  { slug: "juizes", apiSlug: "juizes", name: "Juízes", abbr: "Jz", testament: "AT", chapters: 21 },
  { slug: "rute", apiSlug: "rute", name: "Rute", abbr: "Rt", testament: "AT", chapters: 4 },
  { slug: "1samuel", apiSlug: "1 samuel", name: "1 Samuel", abbr: "1Sm", testament: "AT", chapters: 31 },
  { slug: "2samuel", apiSlug: "2 samuel", name: "2 Samuel", abbr: "2Sm", testament: "AT", chapters: 24 },
  { slug: "1reis", apiSlug: "1 reis", name: "1 Reis", abbr: "1Rs", testament: "AT", chapters: 22 },
  { slug: "2reis", apiSlug: "2 reis", name: "2 Reis", abbr: "2Rs", testament: "AT", chapters: 25 },
  { slug: "1cronicas", apiSlug: "1 cronicas", name: "1 Crônicas", abbr: "1Cr", testament: "AT", chapters: 29 },
  { slug: "2cronicas", apiSlug: "2 cronicas", name: "2 Crônicas", abbr: "2Cr", testament: "AT", chapters: 36 },
  { slug: "esdras", apiSlug: "esdras", name: "Esdras", abbr: "Ed", testament: "AT", chapters: 10 },
  { slug: "neemias", apiSlug: "neemias", name: "Neemias", abbr: "Ne", testament: "AT", chapters: 13 },
  { slug: "ester", apiSlug: "ester", name: "Ester", abbr: "Et", testament: "AT", chapters: 10 },
  // Poéticos / Sapienciais
  { slug: "jo", apiSlug: "jo", name: "Jó", abbr: "Jó", testament: "AT", chapters: 42 },
  { slug: "salmos", apiSlug: "salmos", name: "Salmos", abbr: "Sl", testament: "AT", chapters: 150 },
  { slug: "proverbios", apiSlug: "proverbios", name: "Provérbios", abbr: "Pv", testament: "AT", chapters: 31 },
  { slug: "eclesiastes", apiSlug: "eclesiastes", name: "Eclesiastes", abbr: "Ec", testament: "AT", chapters: 12 },
  { slug: "cantares", apiSlug: "cantares", name: "Cantares", abbr: "Ct", testament: "AT", chapters: 8 },
  // Profetas Maiores
  { slug: "isaias", apiSlug: "isaias", name: "Isaías", abbr: "Is", testament: "AT", chapters: 66 },
  { slug: "jeremias", apiSlug: "jeremias", name: "Jeremias", abbr: "Jr", testament: "AT", chapters: 52 },
  { slug: "lamentacoes", apiSlug: "lamentacoes", name: "Lamentações", abbr: "Lm", testament: "AT", chapters: 5 },
  { slug: "ezequiel", apiSlug: "ezequiel", name: "Ezequiel", abbr: "Ez", testament: "AT", chapters: 48 },
  { slug: "daniel", apiSlug: "daniel", name: "Daniel", abbr: "Dn", testament: "AT", chapters: 12 },
  // Profetas Menores
  { slug: "oseias", apiSlug: "oseias", name: "Oseias", abbr: "Os", testament: "AT", chapters: 14 },
  { slug: "joel", apiSlug: "joel", name: "Joel", abbr: "Jl", testament: "AT", chapters: 3 },
  { slug: "amos", apiSlug: "amos", name: "Amós", abbr: "Am", testament: "AT", chapters: 9 },
  { slug: "obadias", apiSlug: "obadias", name: "Obadias", abbr: "Ob", testament: "AT", chapters: 1 },
  { slug: "jonas", apiSlug: "jonas", name: "Jonas", abbr: "Jn", testament: "AT", chapters: 4 },
  { slug: "miqueias", apiSlug: "miqueias", name: "Miqueias", abbr: "Mq", testament: "AT", chapters: 7 },
  { slug: "naum", apiSlug: "naum", name: "Naum", abbr: "Na", testament: "AT", chapters: 3 },
  { slug: "habacuque", apiSlug: "habacuque", name: "Habacuque", abbr: "Hc", testament: "AT", chapters: 3 },
  { slug: "sofonias", apiSlug: "sofonias", name: "Sofonias", abbr: "Sf", testament: "AT", chapters: 3 },
  { slug: "ageu", apiSlug: "ageu", name: "Ageu", abbr: "Ag", testament: "AT", chapters: 2 },
  { slug: "zacarias", apiSlug: "zacarias", name: "Zacarias", abbr: "Zc", testament: "AT", chapters: 14 },
  { slug: "malaquias", apiSlug: "malaquias", name: "Malaquias", abbr: "Ml", testament: "AT", chapters: 4 },

  // Novo Testamento, Evangelhos + Atos
  { slug: "mateus", apiSlug: "mateus", name: "Mateus", abbr: "Mt", testament: "NT", chapters: 28 },
  { slug: "marcos", apiSlug: "marcos", name: "Marcos", abbr: "Mc", testament: "NT", chapters: 16 },
  { slug: "lucas", apiSlug: "lucas", name: "Lucas", abbr: "Lc", testament: "NT", chapters: 24 },
  { slug: "joao", apiSlug: "joao", name: "João", abbr: "Jo", testament: "NT", chapters: 21 },
  { slug: "atos", apiSlug: "atos", name: "Atos", abbr: "At", testament: "NT", chapters: 28 },
  // Cartas Paulinas
  { slug: "romanos", apiSlug: "romanos", name: "Romanos", abbr: "Rm", testament: "NT", chapters: 16 },
  { slug: "1corintios", apiSlug: "1 corintios", name: "1 Coríntios", abbr: "1Co", testament: "NT", chapters: 16 },
  { slug: "2corintios", apiSlug: "2 corintios", name: "2 Coríntios", abbr: "2Co", testament: "NT", chapters: 13 },
  { slug: "galatas", apiSlug: "galatas", name: "Gálatas", abbr: "Gl", testament: "NT", chapters: 6 },
  { slug: "efesios", apiSlug: "efesios", name: "Efésios", abbr: "Ef", testament: "NT", chapters: 6 },
  { slug: "filipenses", apiSlug: "filipenses", name: "Filipenses", abbr: "Fp", testament: "NT", chapters: 4 },
  { slug: "colossenses", apiSlug: "colossenses", name: "Colossenses", abbr: "Cl", testament: "NT", chapters: 4 },
  { slug: "1tessalonicenses", apiSlug: "1 tessalonicenses", name: "1 Tessalonicenses", abbr: "1Ts", testament: "NT", chapters: 5 },
  { slug: "2tessalonicenses", apiSlug: "2 tessalonicenses", name: "2 Tessalonicenses", abbr: "2Ts", testament: "NT", chapters: 3 },
  { slug: "1timoteo", apiSlug: "1 timoteo", name: "1 Timóteo", abbr: "1Tm", testament: "NT", chapters: 6 },
  { slug: "2timoteo", apiSlug: "2 timoteo", name: "2 Timóteo", abbr: "2Tm", testament: "NT", chapters: 4 },
  { slug: "tito", apiSlug: "tito", name: "Tito", abbr: "Tt", testament: "NT", chapters: 3 },
  { slug: "filemom", apiSlug: "filemom", name: "Filemom", abbr: "Fm", testament: "NT", chapters: 1 },
  // Cartas Gerais + Apocalipse
  { slug: "hebreus", apiSlug: "hebreus", name: "Hebreus", abbr: "Hb", testament: "NT", chapters: 13 },
  { slug: "tiago", apiSlug: "tiago", name: "Tiago", abbr: "Tg", testament: "NT", chapters: 5 },
  { slug: "1pedro", apiSlug: "1 pedro", name: "1 Pedro", abbr: "1Pe", testament: "NT", chapters: 5 },
  { slug: "2pedro", apiSlug: "2 pedro", name: "2 Pedro", abbr: "2Pe", testament: "NT", chapters: 3 },
  { slug: "1joao", apiSlug: "1 joao", name: "1 João", abbr: "1Jo", testament: "NT", chapters: 5 },
  { slug: "2joao", apiSlug: "2 joao", name: "2 João", abbr: "2Jo", testament: "NT", chapters: 1 },
  { slug: "3joao", apiSlug: "3 joao", name: "3 João", abbr: "3Jo", testament: "NT", chapters: 1 },
  { slug: "judas", apiSlug: "judas", name: "Judas", abbr: "Jd", testament: "NT", chapters: 1 },
  { slug: "apocalipse", apiSlug: "apocalipse", name: "Apocalipse", abbr: "Ap", testament: "NT", chapters: 22 },
];

export const findBookBySlug = (slug) =>
  BIBLE_BOOKS.find((b) => b.slug === slug) || null;

/** Maps legacy slugs from the bundled bible.json so existing links keep working. */
export const LEGACY_SLUG_ALIAS = {
  jo: "joao", // the old bundled dataset used "joao" already; defensive mapping
};
